import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutTariffLookup } from "./autogen/AutogenLayoutTariffLookup";

export class TariffLookup extends AutogenLayoutTariffLookup {

    tableTariffOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }
}
